import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

export class SetIntegrationTokenExpiredShouldOpen extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetIntegrationTokenExpiredShouldOpen';

    public constructor(public shouldOpen: boolean) {
        super(SetIntegrationTokenExpiredShouldOpen.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: SetIntegrationTokenExpiredShouldOpen): void => {
    state.shouldOpenIntegrationTokenExpiredDialog = action.shouldOpen;
};

//@ts-ignore
registerReducer(SetIntegrationTokenExpiredShouldOpen.ACTION_TYPE, reducer);
